import { Component, Input, ViewEncapsulation } from '@angular/core';

declare var dataLayer: any;

@Component({
  selector: 'pq-image-list',
  templateUrl: './image.list.component.html',
  styleUrls: ['./_image.list.component.scss']
})
export class ImageListComponent {
  public images: Object[] = [];
  public titleCharLimit: number = 50;
  public imgUrl: string = '/document/';

  @Input() set profile (value: string) {
    if (value && value !== 'undefined') {
      this.imgUrl = '/' + value + '/' + 'document/';
    }
  }

  @Input() set imageResults (images: Object[]) {
    let collection = [];

    images.forEach((image) => {
      if (image['attributes']['thumbnailImage']) { // nightly env sends invalid sourcetype results because sourceRollUpType matches but not the sourceType. So safe to check.
       collection.push({
        id: image['attributes'].goid,
        src: image['attributes']['thumbnailImage'].src,
        title: image['attributes']['thumbnailImage'].altText || image['attributes']['title'],
        altText: image['attributes']['thumbnailImage'].altText || image['attributes']['title'],
        searchId: image['attributes']['searchId']
       });
      }
    });

    this.images = collection;
  };

  public pushResultImgObjClickToGA(goid: String, image: Object) {
    if (image) {
      let position = this.images.indexOf(image);
      position = position + 1;
      if (dataLayer && Array.isArray(dataLayer)) {
        dataLayer.push({
          'event': 'ResultsDocClick',
          'label': 'Full Image#' + goid,
          'position': position
        });
      }
    }
  }

  public trackByFn (index: number, item: object): number {
    return item['id'];
  }
}
